import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";
import { useTranslation } from "react-i18next";

import { buildHelpSupportUrl } from "../utils/help-support";
import { HELP_TIER_SUPERVISOR } from "../utils/help-support";

export default function Footer() {
  const { t, i18n } = useTranslation();
  const currentYear = new Date().getFullYear();
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        color: "black",
        borderTop: 1,
        borderTopWidth: 1,
        borderTopColor: "#E0E0E0",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        padding: 1,
      }}
    >
      <Typography
        sx={{
          fontFamily: "Roboto",
          fontSize: "12px",
          fontWeight: 400,
          color: "rgba(0, 0, 0, 0.6)",
          paddingLeft: "24px",
        }}
      >
        {t("login_all-rights-reserved", { year: currentYear })}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          paddingRight: "24px",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Roboto",
            fontSize: "12px",
            fontWeight: 400,
            color: "rgba(0, 0, 0, 0.87)",
            cursor: "pointer",
            marginRight: "24px",
          }}
          onClick={() =>
            window.open(
              buildHelpSupportUrl({
                tier: HELP_TIER_SUPERVISOR,
                language: i18n.language,
              }),
              "_blank"
            )
          }
        >
          {t("login_help-and-support")}
        </Typography>
        <Typography
          sx={{
            fontFamily: "Roboto",
            fontSize: "12px",
            fontWeight: 400,
            color: "rgba(0, 0, 0, 0.87)",
            cursor: "pointer",
          }}
          onClick={() => window.open("https://wilya.com/privacy", "_blank")}
        >
          {t("login_privacy-policy")}
        </Typography>
      </Box>
    </Box>
  );
}
